import Header from "../../components/header/Header";
import styles from "../favourites/Favourites.module.scss";
import SideBar from "../../components/sideBar/SideBar";
import Footer from "../../components/footer/Footer";
import React from "react";
import useWindowSize from "../../hooks/useWindowSize";
import {useTranslation} from "react-i18next";
import EmptyState from "../../components/shared/EmptyState";

const NotFoundPage = () => {
  const { windowSize } = useWindowSize();
  const { t } = useTranslation();

  return (
    <>
      <section>
        <Header className={styles.headerWrapper}/>
        {windowSize !== "mobile" ? <SideBar/> : null}
        <div className={styles.notFoundWrapper}>
          <EmptyState variant="notFound" text={t("notFound")} />
        </div>
        <Footer source={''}/>
      </section>
    </>
  )
}

export default NotFoundPage;
